export default __webpack_public_path__ + "static/media/BQB.aa60f0b4.png";